module.exports = __webpack_public_path__ + "img/01logo-gkc2022.6fc2f9ea.png";